import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from "rxjs/operators";
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    api = environment.apiEndpoint;

    constructor(private httpclient: HttpClient) {
    }

    /**
     * Search content within a service
     * @param token - JWT token
     * @param serviceSlug - Service slug to search within
     * @param query - Search query string
     * @param page - Page number for pagination
     * @param perPage - Results per page
     */
    searchContent(token: string, serviceSlug: string, query: string, page: number = 1, perPage: number = 10): Observable<SearchResponse> {
        const params = `token=${token}&service_slug=${encodeURIComponent(serviceSlug)}&query=${encodeURIComponent(query)}&page=${page}&per_page=${perPage}`;
        return this.httpclient.get<SearchResponse>(this.api + "auth/search?" + params).pipe(
            map((data) => {
                return data;
            })
        );
    }
}

export interface SearchResult {
    type: string;
    id: number;
    title: string;
    description: string;
    excerpt: string;
    thumbnail: string;
    chapter_id: number;
    chapter_name: string;
    chapter_slug: string;
    cluster_id?: number;
    cluster_name: string;
    module_id: number;
    module_name: string;
    module_slug: string;
    module_type: number;
    page_number?: number;
    color?: string;
}

export interface SearchResponse {
    status: boolean;
    query: string;
    service_id: number;
    service_name: string;
    service_slug: string;
    total_results: number;
    modules_count: number;
    current_page: number;
    per_page: number;
    total_pages: number;
    results: SearchResult[];
    message?: string;
}
